import { render, staticRenderFns } from "./MpesaPaymentDetails.vue?vue&type=template&id=06f24d06&"
import script from "./MpesaPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./MpesaPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports